import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AddMultipleComponent, IAddedItem } from 'components/input/add-multiple/add-multiple.component';
import { TagModel } from 'models/generated/Models.TagModel';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'tags',
	templateUrl: './tags.component.html',
	imports: [AddMultipleComponent, TranslatePipe]
})
export class TagsComponent {

	selectedItems: IAddedItem[] = [];

	private _selectedTags: TagModel[] = [];
	@Input() set selectedTags(value: TagModel[]) {
		this._selectedTags = value;
		this.selectedItems = value.map((tag) => { return { value: tag.tag, label: tag.tag }; });
	}
	get selectedTags() { return this._selectedTags; }

	tagItems: IAddedItem[] = [];
	@Input()
	set tags(value: TagModel[]) {
		this.tagItems = value.map((tag) => { return { value: tag.tag, label: tag.tag } });
	}
	@Output() selectedTagsChange = new EventEmitter<TagModel[]>();

	onChange(selectedItems: IAddedItem[]) {
		const removeItems = this.selectedTags.filter(tag => selectedItems.map(i => i.value.toLowerCase()).indexOf(tag.tag.toLowerCase()) < 0);
		const addItems = selectedItems.filter(item => this.selectedTags.map(t => t.tag.toLowerCase()).indexOf(item.value.toLowerCase()) < 0);

		for (let removeItem of removeItems) {
			this.selectedTags.splice(this.selectedTags.indexOf(removeItem), 1);
		}
		for (let addItem of addItems) {
			const newTag = new TagModel();
			newTag.tag = addItem.value;
			this.selectedTags.push(newTag);
		}
		this.selectedTagsChange.emit(this.selectedTags);
	}
}
